import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-solid-svg-icons';

import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import esCR from 'date-fns/locale/es';
registerLocale('es', esCR);

class DatePickerControl extends Component {
       
    render() {
        const CustomInput = ({ value, onClick, onChange }) => (

            <div className="input-group">
                <input className="form-control" onClick={onClick} value={value} onChange={onChange} />
                <div className="input-group-append">
                    <span className="input-group-text" onClick={onClick}><FontAwesomeIcon icon={faClock} /></span>
                </div>
            </div>);

        return <DatePicker
            locale="es"
            {...this.props.props}
            dropdownMode="select"
            selected={this.props.value}
            onChange={date => this.props.onChange(this.props.name, date)}
            customInput={<CustomInput />}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={this.props.timeIntervals}
            timeCaption="Hora"
            dateFormat={this.props.dateFormat}
        />;
    }
}

export default DatePickerControl;